import { render, staticRenderFns } from "./table-tr.vue?vue&type=template&id=ba541e0e&"
import script from "./table-tr.vue?vue&type=script&lang=js&"
export * from "./table-tr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports